import type { ReactNode } from "react";
import { cn } from "../lib/cn";

/**
 * A record's facts under its title, as a grid a person scans instead of a sentence: who, where it stands, when, how
 * much. Two to a row on a phone, three from `md`, five from `lg`. The order page and a release's page open with it.
 */
export function Facts({ className, children }: { className?: string; children: ReactNode }) {
  return <dl className={cn("grid grid-cols-2 gap-x-8 gap-y-5 md:grid-cols-3 lg:grid-cols-5", className)}>{children}</dl>;
}

/**
 * One fact: its label, the value, and what qualifies it on a second, smaller line (by whom, the cutoff, before VAT).
 * A fact whose second line runs long (a release's steps) takes `className="col-span-2"`.
 */
export function Fact({ label, sub, className, children }: { label: ReactNode; sub?: ReactNode; className?: string; children: ReactNode }) {
  return (
    <div className={cn("flex min-w-0 flex-col gap-1", className)}>
      <dt className="text-2xs font-medium uppercase tracking-wider text-ink-3">{label}</dt>
      <dd className="text-base text-ink">{children}</dd>
      {sub && <dd className="text-xs text-ink-3">{sub}</dd>}
    </div>
  );
}
